import { ContactDetailsBox } from '@lemontaps/lib/types/api';
import {
  Link,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import IconRenderer from './IconRenderer';

type Props = ContactDetailsBox['rows'][number];

export default function ContactDetail({
  icon: { name: iconName },
  href,
  lines,
  label,
  rowClassName,
  iconClassName,
  labelClassName,
}: Props) {
  return (
    <ListItem disablePadding className={rowClassName}>
      <ListItemButton component={Link} href={href} target='_blank'>
        <ListItemIcon className={iconClassName}>
          <IconRenderer name={iconName} />
        </ListItemIcon>
        <ListItemText className={labelClassName}>
          {lines.map(line => (
            <Typography key={line.text} variant='body2' color='secondary'>
              {line.text}
            </Typography>
          ))}
          {label && (
            <Typography variant='caption' color='secondary'>
              {label}
            </Typography>
          )}
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
}
